import { AxiosInstance, AxiosError } from "axios";
import { BaseApi } from "../base-api";
import {
  IGetAllProjectsResponseModel,
  IGetProjectRequestModel,
  IGetProjectResponseModel,
  IProjectsApi,
  IUpdateProjectRequestModel,
} from "@lib/types";

export class ProjectsApi extends BaseApi implements IProjectsApi {
  constructor(instance: AxiosInstance) {
    super(instance);
  }

  async get(
    account: number,
    projectId: number,
    requestModel: IGetProjectRequestModel,
  ): Promise<IGetProjectResponseModel> {
    try {
      const searchParams = new URLSearchParams(requestModel.params);

      const response = await this._instance.get<IGetProjectResponseModel>(
        `/accounts/${account}/projects/${projectId}?${searchParams}`,
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }

  async getAll(
    account_number: number,
  ): Promise<Array<IGetAllProjectsResponseModel>> {
    try {
      const response = await this._instance.get<
        Array<IGetAllProjectsResponseModel>
      >(`/accounts/${account_number}/projects`);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }

  async put(
    account_number: number,
    project_id: number,
    requestModel: IUpdateProjectRequestModel,
  ): Promise<void> {
    try {
      await this._instance.put(
        `/accounts/${account_number}/projects/${project_id}`,
        requestModel,
      );
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }
}
